export default "__VITE_ASSET__wZsB_xhB__"